module.exports = __webpack_public_path__ + "img/omniverse.8df4528c.svg";